import api from './api';

// Saved words live in the lexical system (same store the extension uses).
export const getVocabularies = async (params) => {
  const { data } = await api.get('/v1/user_lexical_entries', { params });
  return data;
};

export const saveVocabulary = async ({ word, translation }) => {
  const { data } = await api.post('/v1/user_lexical_entries', { word, translation });
  return data;
};

export const deleteVocabulary = async (id) => {
  const { data } = await api.delete(`/v1/user_lexical_entries/${id}`);
  return data;
};

export const updateVocabulary = async ({ id, ...params }) => {
  const { data } = await api.patch(`/v1/user_lexical_entries/${id}`, params);
  return data;
};

export const getErrorMessage = (error) => {
  const status = error?.response?.status;
  if (status === 402) return 'Free plan limit reached. Upgrade to save more words.';
  if (status === 409) return 'This word is already in your list.';
  if (status === 401) return 'Your session expired. Please sign in again.';
  return error?.response?.data?.message || 'Something went wrong. Please try again.';
};
